import { createAsyncThunk } from '@reduxjs/toolkit';

import type {
  ConvidarMembroDto,
  ListarConvitesFilters,
  PapelEscritorio,
} from '@/types/escritorio/escritorioTypes';

import { escritorioConvitesService } from './services';

export const convidarMembro = createAsyncThunk(
  'escritorio/convites/convidar',
  async (
    { escritorioId, data }: { escritorioId: string; data: ConvidarMembroDto },
    { rejectWithValue },
  ) => {
    try {
      return await escritorioConvitesService.convidar(escritorioId, data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const listarConvites = createAsyncThunk(
  'escritorio/convites/listar',
  async (
    { escritorioId, filters }: { escritorioId: string; filters?: ListarConvitesFilters },
    { rejectWithValue },
  ) => {
    try {
      return await escritorioConvitesService.listar(escritorioId, filters);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const aceitarConvite = createAsyncThunk(
  'escritorio/convites/aceitar',
  async (token: string, { rejectWithValue }) => {
    try {
      return await escritorioConvitesService.aceitar(token);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const buscarConvitePorToken = createAsyncThunk(
  'escritorio/convites/buscarPorToken',
  async (token: string, { rejectWithValue }) => {
    try {
      return await escritorioConvitesService.buscarPorToken(token);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const cancelarConvite = createAsyncThunk(
  'escritorio/convites/cancelar',
  async (
    { escritorioId, conviteId }: { escritorioId: string; conviteId: string },
    { rejectWithValue },
  ) => {
    try {
      await escritorioConvitesService.cancelar(escritorioId, conviteId);
      return conviteId;
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const convidarComSetores = createAsyncThunk(
  'escritorio/convites/convidarComSetores',
  async (
    {
      escritorioId,
      data,
    }: {
      escritorioId: string;
      data: {
        email: string;
        papel: Exclude<PapelEscritorio, 'MASTER_ADMIN'>;
        setorIds: string[];
        observacoes?: string;
        nomeConvidado?: string;
      };
    },
    { rejectWithValue },
  ) => {
    try {
      return await escritorioConvitesService.convidarComSetores(escritorioId, data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
